/**
 * Pendant zu `<IwmDropdownRechnungsart>` / `<IwmDropdownRechnungsartAufteilung>`; beide
 * geben die Validierungsmeldung selbst aus (`ValidationFor`).
 */

import { EnumDropdown } from '@/components/inputs/EnumDropdown';

import { asNumber, type FieldAccess } from './fieldAccess';
import { FormField } from './FormField';

export interface EnumFieldProps<T, TEnum extends number> {
  form: FieldAccess<T>;
  name: keyof T & string;
  displayNames: Record<TEnum, string>;
  /** Beschriftung über dem Feld — Text unverändert aus REQ-10 §4. */
  label: string;
}

/** `default(TEnum)` — Syncfusion schreibt das beim Leeren einer nicht nullbaren Auswahl. */
const DEFAULT_ENUM_VALUE = 0;

export function EnumField<T, TEnum extends number>(props: EnumFieldProps<T, TEnum>) {
  const { form, name } = props;
  const field = form.viewField(name);
  if (field === null) return null;

  return (
    <FormField message={form.message(name)}>
      <EnumDropdown<TEnum>
        value={asNumber(form.value(name)) as TEnum | null}
        displayNames={props.displayNames}
        label={props.label}
        readOnly={field.ReadOnly}
        onChange={(value) => {
          form.setValue(name, value ?? DEFAULT_ENUM_VALUE);
        }}
      />
    </FormField>
  );
}

export default EnumField;
